import Vue from 'vue';
import Vuex from 'vuex';

import loginStore from '../components/login/login-store.js';
import countriesStore from '../components/master-maintenance/setup/country/countries-store.js';
import districtStore from '../components/master-maintenance/setup/district/districts-store.js';
import currencyRateStore from '../components/master-maintenance/setup/currency/currencyrate-store.js';
import departmentsStore from '../components/master-maintenance/setup/department/departments-store.js';
import locationStore from '../components/master-maintenance/setup/location/location-store.js';
import locationTypeStore from '../components/master-maintenance/setup/location-type/location-type-store.js';
import localizationStore from '../components/localization/localization-store.js';
import transactionStore from '../components/master-maintenance/setup/transaction/transaction-store.js';
import entityLocationStore from '../components/master-maintenance/business-partner/entity-location/entity-location-store.js';
import customerCategoryStore from '../components/master-maintenance/business-partner/customer-category/customer-category-store.js';
import vendorCategoryStore from '../components/master-maintenance/business-partner/vendor-category/vendor-category-store.js';
import paymentTermStore from '../components/master-maintenance/business-partner/payment-term/payment-term-store.js';
import miscellaneousChargesStore from '../components/master-maintenance/business-partner/miscellaneous-charges/miscellaneous-charges-store.js';
import priceClassStore from '../components/master-maintenance/business-partner/price-class/price-class-store.js';
import remarkStore from '../components/master-maintenance/others/remark/remark-store.js';
import itemMasterStore from '../components/stock-item/item-master/item-master-store.js';
import category1Store from '../components/stock-item/category1/category1-store.js';
import category2Store from '../components/stock-item/category2/category2-store.js';
import binStore from '../components/stock-item/bin/bin-store.js';
import brandsStore from '../components/stock-item/brand/brand-store.js';
import seriesStore from '../components/stock-item/series/series-store.js';
import characterStore from '../components/stock-item/character/character-store.js';
import itemLineStore from '../components/stock-item/itemLine/itemLine-store.js';
import vendorStore from '../components/stock-item/item-master/vendor-store.js';
import currencyStore from '../components/stock-item/item-master/currency-store.js';
import entityStore from '../components/stock-item/item-master/entity-store.js';
import invoiceStore from '../components/sales/invoice/invoice-store.js';
import purchaseOrdersStore from '../components/purchase-order/purchase-order-store.js';
import commonStore from '../components/common/common-store.js';
import salesOrderStore from '../components/sales/sales-order/sales-order-store.js';
import businessEntityStore from '../components/master-maintenance/business-partner/business-entity/business-entity-store.js';

import goodsReceiveStore from '../components/inventory-control/goods-receive/goods-receive-store.js';
import goodsReceivePostStore from '../components/inventory-control/goods-receive-post/goods-receive-post-store.js';
import stockTransferStore from '../components/inventory-control/stock-transfer/stock-transfer-store.js';
import qtyAdjustmentStore from '../components/inventory-control/qty-adjustment/qty-adjustment-store.js';
// import costAdjustmentStore from '../components/inventory-control/cost-adjustment/cost-adjustment-store.js';
// import stockTakeStore from '../components/inventory-control/stock-take/stock-take-store.js';
// import purchaseReturnStore from '../components/inventory-control/purchase-return/purchase-return-store.js';
import stockBalanceEnquiryStore from '../components/inventory-control/enquiry/stock-balance-enquiry/stock-balance-enquiry-store.js';
import stockBalanceMultiStore from '../components/inventory-control/enquiry/stock-balance-multi/stock-balance-multi-store.js';
import deliverySummaryStore from '../components/inventory-control/enquiry/delivery-summary/delivery-summary-store.js';
import invoicePrintingStore from '../components/sales/invoice-printing/invoice-printing-store.js';
import invoicePostStore from '../components/sales/invoice-post/invoice-post-store.js';
import txPostXeroStore from '../components/sales/tx-post-xero/tx-post-xero-store.js';
import invoiceSettlementStore from '../components/sales/invoice-settlement/invoice-settlement-store.js';
import invoiceSummaryStore from '../components/sales/invoice-summary/invoice-summary-store.js';
import invoiceStatusStore from '../components/sales/invoice-status/invoice-status-store.js';
import dashboardStore from '../components/dashboard/dashboard-store.js';

import functionSecurityStore from '../components/admin/functionsecurity/function-security-store.js';
import userGrpRightsStore from '../components/admin/functionsecurity/user-grp-rights-store.js';
import userGrpMaintenanceStore from '../components/admin/usergrpmaintenance/user-grp-maintenance-store.js';
import userMaintenanceStore from '../components/admin/usermaintenance/user-maintenance-store.js';

import periodStore from '../components/master-maintenance/setup/fiscal-period/period-store.js';
import systemParameterUserStore from '../components/system-admin/system-parameter-user/system-parameter-user-store.js';
// 20230802
import userGrpRightsShopStore from '../components/admin/user-grp-rights-shop/user-grp-rights-shop-store.js';
import sysmenuShopStore from '../components/admin/user-grp-rights-shop/sysmenu-shop-store.js';
import shopUserMaintenanceStore from '../components/admin/shopuser-maintenance/shopuser-maintenance-store.js';

import GREnquiryStore from '../components/inventory-control/enquiry/gr-enquiry/gr-enquiry-store.js';
// 20230802
import salesReturnStore from '../components/sales/sales-return/sales-return-store.js';
import goodsPickingStore from '../components/sales/goods-picking-verification/goods-picking-store.js';

import productlineChargeStore from '../components/inventory-control/product-line-in-charge/product-line-in-charge-store.js';

import newOrderStore from '../components/new-order/new-order-store.js';
import shoppingCartStore from '../components/new-order/shopping-cart-store.js';
import okPopupStore from '../custom-components/ok-popup/ok-popup-store.js';
import orderStatusStore from '../components/order-status/order-status-store.js';

import salesEnquiryStore from '../components/sales/enquiry/sales-enquiry-store.js';
import stockMovementAnalysisStore from '../components/month-end/stock-movement-analysis/stock-movement-analysis-store.js';
import convertpickListToInvoiceStore from '../components/sales/convert-picking-list-to-invoice/convert-pickList-to-invoice-store.js';
import systemParamUserStore from '../components/system-admin/system-parameter-user/system-parameter-user-store.js';

import bundleItemStore from '../components/master-maintenance/setup/bundleitem/bundleitem-store.js';
import shopsStore from '../components/master-maintenance/setup/shops/shops-store.js';
import bundleStore from '../components/master-maintenance/setup/bundleitem/bundle-store.js';
import mixMatchStore from '../components/master-maintenance/business-partner/mix-match/mixMatch-store.js';
import ConvertBatchSOtoInvoiceStore from '../components/sales/convert-Batch-SO-Invoice/ConvertBatchSOtoInvoice-store.js';
import ChangeInvoiceStatusStore from '../components/sales/change-invoice-status/ChangeInvoiceStatus-store.js';
import labelTemplateCreationStore from '../components/stock-item/label-template-creation/label-template-creation-store.js';
import barcodeLabelStore from '../components/stock-item/barcode-label/barcode-label-store.js'

import quotationStore from '../views/Quotation/quotationStore.js';
import todolistStore from '../views/ToDoList/ToDoList-store.js';

import marketInfoStore from '../components/market-info/market-info-store.js';


Vue.use(Vuex)
export const store = new Vuex.Store({
  modules: {
    loginStore,
    countriesStore,
    districtStore,
    departmentsStore,
    locationStore,
    locationTypeStore,
    localizationStore,
    transactionStore,
    brandsStore,
    itemLineStore,
    entityLocationStore,
    customerCategoryStore,
    paymentTermStore,
    miscellaneousChargesStore,
    priceClassStore,
    remarkStore,
    itemMasterStore,
    category1Store,
    category2Store,
    binStore,
    seriesStore,
    characterStore,
    vendorStore,
    currencyStore,
    currencyRateStore,
    entityStore,
    invoiceStore,
    purchaseOrdersStore,
    commonStore,
    salesOrderStore,
    goodsReceiveStore,
    goodsReceivePostStore,
    stockTransferStore,
    invoicePrintingStore,
    invoicePostStore,
    txPostXeroStore,
    qtyAdjustmentStore,
    // costAdjustmentStore,
    // stockTakeStore,
    // purchaseReturnStore,
    stockBalanceEnquiryStore,
    stockBalanceMultiStore,
    deliverySummaryStore,
    invoiceSettlementStore,
    invoiceSummaryStore,
    invoiceStatusStore,
    dashboardStore,
    businessEntityStore,
    functionSecurityStore,
    userGrpMaintenanceStore,
    userMaintenanceStore,
    periodStore,
    systemParameterUserStore,
    userGrpRightsShopStore,
    userGrpRightsStore,
    sysmenuShopStore,
    shopUserMaintenanceStore,
    GREnquiryStore,
    salesReturnStore,
    goodsPickingStore,
    productlineChargeStore,
    salesEnquiryStore,
    newOrderStore,
    vendorCategoryStore,
    shoppingCartStore: shoppingCartStore,
    okPopupStore: okPopupStore,
    orderStatusStore: orderStatusStore,
    stockMovementAnalysisStore,
    convertpickListToInvoiceStore,
    systemParamUserStore,
    bundleItemStore,
    shopsStore,
    bundleStore,
    mixMatchStore,
    ConvertBatchSOtoInvoiceStore,
    ChangeInvoiceStatusStore,
    labelTemplateCreationStore,
    barcodeLabelStore,
    labelTemplateCreationStore,
    barcodeLabelStore,
    quotationStore,
    todolistStore,
    marketInfoStore
  }
})
